import { siteConfig } from "@/config/site.config";

/**
 * Default SEO metadata + a helper to build per-page metadata.
 *
 * The `Seo` component consumes these values. Centralizing them here means
 * future integrations (Open Graph images from a CMS, i18n titles, structured
 * data) plug in without touching pages.
 */

export interface SeoMeta {
  title: string;
  description: string;
  path: string;
  /** Absolute or public-relative image URL for social cards. */
  image?: string;
  /** Prevents indexing (used on legal / thank-you pages if needed). */
  noindex?: boolean;
  type?: "website" | "article";
}

export const defaultSeo: SeoMeta = {
  title: `${siteConfig.name} — ${siteConfig.tagline}`,
  description: siteConfig.description,
  path: "/",
  image: "/og-image.png",
  type: "website",
};

/** Builds a full page title with the brand suffix. */
export function buildTitle(pageTitle?: string): string {
  if (!pageTitle) return defaultSeo.title;
  return `${pageTitle} · ${siteConfig.name}`;
}

/** Builds a canonical absolute URL for a given route path. */
export function buildCanonical(path: string): string {
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `${siteConfig.url}${clean === "/" ? "" : clean}`;
}
